export default function PageShell({ children, className = "" }) {
  return (
    <div
      className={`sm:py-2 sm:px-4 flex flex-col h-[calc(100vh-64px)] sm:h-[calc(100vh-16px)] overflow-hidden ${className}`}
    >
      <div className="bg-white sm:rounded-2xl sm:shadow-sm sm:border sm:border-gray-200 overflow-hidden flex-1 min-h-0 flex flex-col">
        {children}
      </div>
    </div>
  );
}
